import React, { useState } from "react";
import { Button, TextField, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

interface BannedUserPageProps {
  onSubmitAppeal: (comment: string) => Promise<void>;
}

const useStyles = makeStyles({
  container: {
    maxWidth: 600,
    color: "#fff",
    margin: "auto",
    padding: 10,
    textAlign: "center",
    booxShadow: "none",
    "& .MuiDialogTitle-root , .MuiDialogContent-root, .MuiInputBase-input": {
      color: "white",
    },
    "& .MuiFormControl-root": {
      border: "1px solid #ffffff19",
      borderRadius: "8px",
      padding: 20
    }
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 0",
  },
  cancelButton: {
    color: "#FE5A97",
  },
  appealButton: {
    color: "#fff",
    backgroundColor: "#FE5A97",
  },
});

const BannedUserPage: React.FC<BannedUserPageProps> = ({ onSubmitAppeal }) => {
  const classes = useStyles();
  const [showAppealForm, setShowAppealForm] = useState(false);
  const [appealComment, setAppealComment] = useState("");
  const [submittingAppeal, setSubmittingAppeal] = useState(false);

  const handleShowAppealForm = () => setShowAppealForm(true);
  const handleCancelAppeal = () => {
    setShowAppealForm(false);
    setAppealComment("");
  };

  const handleSubmitAppeal = async () => {
    setSubmittingAppeal(true);
    try {
      await onSubmitAppeal(appealComment);
      setShowAppealForm(false);
      setAppealComment("");
    } finally {
      setSubmittingAppeal(false);
    }
  };

  return (
    <div className={classes.container}>
      {/* <h1>User Banned</h1> */}
      {showAppealForm ? (
        <TextField
          fullWidth
          multiline
          rows={4}
          value={appealComment}
          onChange={(e) => setAppealComment(e.target.value)}
          placeholder="Enter your appeal comment..."
        />
      ) : (
        // <p>
        //   Your account has been banned. You can appeal this decision or leave
        //   the page.
        // </p> 
        ""
      )}

      <div className={classes.actions}>
        {showAppealForm ? (
          <>
            <Button
              onClick={handleCancelAppeal}
              className={classes.cancelButton}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmitAppeal}
              className={classes.appealButton}
              disabled={submittingAppeal || !appealComment.trim()}
            >
              {submittingAppeal ? <CircularProgress size={20} /> : "Submit"}
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={handleShowAppealForm}
              className={classes.appealButton}
              style={{ margin: "auto" }}
            >
              Appeal decision
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default BannedUserPage;
